import AssetDetailContent from 'componentsV2/AssetDetailContent/AssetDetailContent';
import React, { useEffect } from 'react';
import './AssetDetail.scss';
import { assetDetailAction } from 'actions/assetDetails';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'components/Placeholders/Loading';
import { findElementByPrompt } from 'utils/utils';
import HeadingNavBar from 'componentsV2/HeadingNavBar/HeadingNavBar';
import AssetAudit from 'componentsV2/AssetAudit/AssetAudit';
import { useLocation } from 'react-router-dom';
import { HOME_PAGE } from 'constants/routes';

const AssetDetail: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState('Metadata');
  const [assetDetails, setAssetDetails] = React.useState<any>(null);
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const loading = useSelector((state: any) => state.loading.isLoading);
  const location = useLocation();
  const url = window.location.href;
  const assetId = url.split('/').pop(); // Extract the last part of the URL

  // Get the 'from' parameter from router state or default to 'home'
  const fromPage = (location.state as any)?.from || HOME_PAGE; // Default to 'home' if not specified

  const handleClick = (tabValue: string) => {
    setActiveTab(tabValue);
  };

  useEffect(() => {
    const fetchAssetDetails = async () => {
      try {
        // Get the asset ID from the URL
        dispatch({ type: 'LOADING SUCCESS', payload: true });
        if (!assetId) {
          console.error('Asset ID is undefined. Unable to fetch asset details.');
          return;
        }
  
        // Fetch asset details using the asset ID
        const response = await assetDetailAction.getAssetDetails(assetId);
        dispatch({ type: 'LOADING SUCCESS', payload: false });

        setAssetDetails(response);
      } catch (error) {
        dispatch({ type: 'LOADING SUCCESS', payload: false });

        console.error('Error fetching asset details:', error);
      }
    };
  
    fetchAssetDetails();
  }, []);

  const nameId = findElementByPrompt(assetDetails, 'Name');
  useEffect(() => {
    document.title = 'Asset Details';
  }, []);

  return (
    <div className="asset-detail" data-testid="asset-detailpage">
      <HeadingNavBar activeTab={activeTab} pageTitle={nameId?.value?.display_value || nameId?.value?.id} name={assetDetails?.name ? ` ${assetDetails.name}` : ''} handleClick={handleClick} assetDetails={assetDetails} 
        from={fromPage}/>
      {/* Render content based on active tab */}
      {activeTab.includes("Metadata") && (
        <AssetDetailContent assetDetails={assetDetails}/>
      )}
      {
        activeTab === "Audit" && (
          <div className="asset-detail-content">
            <AssetAudit assetId={assetId} assetDetails={assetDetails} />
          </div>
        )
      }
      {activeTab === "Versions" && (
        <div className="asset-detail-content">
          <h2>Versions</h2>
          <p>Content for Versions tab will be displayed here.</p>
        </div>
      )}
      {loading && <Loading/>}
    </div>
  );
};

export default AssetDetail;